import { useState } from "react";
import { Loader2, Share2 } from "lucide-react";
import { toast } from "sonner";
import { shareStageCard } from "../lib/stageCard";

export const StageShareButton = ({ trip, day, testId }) => {
  const [busy, setBusy] = useState(false);
  const share = async (e) => {
    e.stopPropagation();
    e.preventDefault();
    setBusy(true);
    try {
      const result = await shareStageCard(trip, day);
      if (result === "downloaded") toast.success("Etappe-afbeelding gedownload — deel hem in je motorgroep!");
    } catch {
      toast.error("Kon de etappe-afbeelding niet maken, probeer opnieuw");
    } finally {
      setBusy(false);
    }
  };
  return (
    <button type="button" data-testid={testId || `share-stage-${day.day_number}`} onClick={share} disabled={busy}
      title="Deel deze etappe als afbeelding in je motorgroep"
      className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-amber-500/15 border border-amber-500/40 text-amber-600 hover:bg-amber-500/30 transition-[background-color] duration-200 shrink-0">
      {busy ? <Loader2 className="w-3 h-3 animate-spin" /> : <Share2 className="w-3 h-3" />}
    </button>
  );
};
